import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { isDisplayNameVisible, isNameReadOnly } from '../../../base/config/functions.any';
import { getParticipantById, isLocalParticipantModerator, isScreenShareParticipantById, getParticipantByIdOrUndefined } from '../../../base/participants/functions';
import DisplayName from '../../../display-name/components/web/DisplayName';
import StatusIndicators from './StatusIndicators';
import { isGuestTmp } from '../../../base/conference/functions';
import Icon from '../../../base/icons/components/Icon';
import { IconVerified } from '../../../base/icons/svg';
import { isBannedChangeName } from '../../../changename-moderation/functions';
const useStyles = makeStyles()((theme) => {
    return {
        nameContainer: {
            display: 'flex',
            overflow: 'hidden',
            alignItems: 'center',
            columnGap: '4px',
            backgroundColor: theme.palette.black + '50',
            height: '100%',
            borderTopRightRadius: '8px',
            padding: '0 8px',
            margin: 0,
            '&>div': {
                display: 'flex',
                overflow: 'hidden'
            },
            '& .jitsi-icon': {
                minWidth: '12px'
            }
        }
    };
});
const ThumbnailBottomIndicators = ({ className, local, participantId, showStatusIndicators = true, thumbnailType, checkIsJibri }) => {
    const { classes: styles, cx } = useStyles();
    const _allowEditing = !useSelector(isNameReadOnly);
    const _defaultLocalDisplayName = interfaceConfig.DEFAULT_LOCAL_DISPLAY_NAME;
    const _showDisplayName = useSelector(isDisplayNameVisible);
    const isVirtualScreenshareParticipant = useSelector((state) => isScreenShareParticipantById(state, participantId));
    const isVerifiedUser = !isGuestTmp();
    const participant = getParticipantById(APP.store.getState(), participantId ?? '');
    const isOwner = isLocalParticipantModerator(APP.store.getState());
    const isAllowEditing = () => {
        if (isOwner) {
            return true;
        }
        else {
            if (participant) {
                return !isBannedChangeName(participant, APP.store.getState());
            }
        }
    };
    const _participant = useSelector((state) => getParticipantByIdOrUndefined(state, participantId));
    return (React.createElement("div", { className: cx(className, 'bottom-indicators') },
        _showDisplayName && (React.createElement("span", { className: styles.nameContainer },
            _participant?.email && React.createElement(Icon, { src: IconVerified, size: 12, color: 'transparent' }),
            React.createElement(DisplayName, { allowEditing: (local && isAllowEditing()) ? _allowEditing : false, displayNameSuffix: local ? _defaultLocalDisplayName : '', elementID: local ? 'localDisplayName' : `participant_${participantId}_name`, participantID: participantId, thumbnailType: thumbnailType }))),
        !checkIsJibri && showStatusIndicators && React.createElement(StatusIndicators, { audio: !isVirtualScreenshareParticipant, moderator: false, participantID: participantId, screenshare: isVirtualScreenshareParticipant && false, thumbnailType: thumbnailType })));
};
export default ThumbnailBottomIndicators;
